export default __webpack_public_path__ + "static/Filters-348c44197a3cde0e9982fd7560139502.png";